
import {spApi} from './sp'


export const getSubscriptionDetailsApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscriptionDetails: builder.query({
      query: ({authType, token}) => `/getsubscriptiondetails?authType=${authType}&&token=${token}`,
    }),
    providesTags: ['Subscription'],
    

  }),
  overrideExisting: false,
})

export const { useGetSubscriptionDetailsQuery, usePrefetch } = getSubscriptionDetailsApi